import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessMessageProperty } from './process-message-property';
export { ProcessMessageProperty };
import { processMessagePropertySchema } from '@schemas/business-objects/process-message-property';
import { ProcessDataTypeFormGroup } from './process-data-type-form-group';
import { ProcessMessageFormGroup } from './process-message-form-group';

export class ProcessMessagePropertyFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    isArray: SchemaFormControl;
    required: SchemaFormControl;
    description: SchemaFormControl;
    sequence: SchemaFormControl;
    messageId: SchemaFormControl;
    message: ProcessMessageFormGroup;
    typeId: SchemaFormControl;
    type: ProcessDataTypeFormGroup;
  };

  declare value: Partial<ProcessMessageProperty>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processMessagePropertySchema, ProcessMessageProperty, data, options);
  }

  get object(): ProcessMessageProperty {
    return new ProcessMessageProperty(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'message':
        return new ProcessMessageFormGroup();
      case 'type':
        return new ProcessDataTypeFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessMessageProperty[]> {
    return ProcessMessageProperty.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessMessageProperty | null> {
    return ProcessMessageProperty.findOne(filter);
  }

  static async findById(
    id: string,
    filter?: any,
  ): Promise<ProcessMessageProperty> {
    return ProcessMessageProperty.findById(id, filter);
  }

  static async create(
    data: Partial<ProcessMessageProperty>,
  ): Promise<ProcessMessageProperty> {
    return ProcessMessageProperty.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessMessageProperty>,
  ): Promise<ProcessMessageProperty> {
    return ProcessMessageProperty.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessMessageProperty.deleteById(id);
  }
}

export class ProcessMessagePropertyFormArray extends PersistedFormArray {
  declare controls: ProcessMessagePropertyFormGroup[];

  readonly entityName = 'ProcessMessageProperty' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processMessagePropertySchema, ProcessMessageProperty, options);
  }

  protected override createItemGroup() {
    return new ProcessMessagePropertyFormGroup();
  }

  get array(): ProcessMessageProperty[] {
    return this.controls.map(
      (group: ProcessMessagePropertyFormGroup) => group.object,
    );
  }
}

export class ProcessMessagePropertyPersistedArray extends PersistedArray<ProcessMessageProperty> {
  readonly entityName = 'ProcessMessageProperty' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessMessageProperty, options);
  }
}
